import {
  SuspiciousCardTxnActionInput,
  SuspiciousCardTxnActionResult,
} from '@varo/graphql-schema-types';
import SubmitSuspiciousCardTransactionStatus from 'services/graphql/mutations/SubmitSuspiciousCardTransactionStatus';
import { CombinedError, useMutation } from 'urql';

interface SubmitSuspiciousCardTransactionHookOutput {
  fetching: boolean;
  error?: CombinedError;
  suspiciousCardTxnAction: SuspiciousCardTxnActionResult | undefined;
  onSubmitSuspiciousCardTransactionStatus: (
    input: SuspiciousCardTxnActionInput,
  ) => Promise<{
    data?: { suspiciousCardTxnAction: SuspiciousCardTxnActionResult };
    error?: CombinedError;
  }>;
}

export const useSubmitSuspiciousTransactionStatus =
  (): SubmitSuspiciousCardTransactionHookOutput => {
    const [{ data, fetching, error }, submitSuspiciousCardTransactionStatus] =
      useMutation<{
        suspiciousCardTxnAction: SuspiciousCardTxnActionResult;
      }>(SubmitSuspiciousCardTransactionStatus);

    const onSubmitSuspiciousCardTransactionStatus = async (
      input: SuspiciousCardTxnActionInput,
    ) => {
      return await submitSuspiciousCardTransactionStatus({ input });
    };

    return {
      fetching,
      suspiciousCardTxnAction: data?.suspiciousCardTxnAction,
      error,
      onSubmitSuspiciousCardTransactionStatus,
    };
  };
